var render, staticRenderFns
import script from "./-index.tsx?vue&type=script&lang=js&"
export * from "./-index.tsx?vue&type=script&lang=js&"
import style0 from "./_todo_slug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports